import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Text } from 'components/common/Elements/Elements';

import classes from './ActiveLabel.module.scss';

const ActiveLabel = ({ labelChange, name, value, text, className }) => {
  return (
    <label className={classes.label}>
      <input
        onChange={labelChange}
        className={classes.visually_hidden}
        type="checkbox"
        name={name}
        value={value}
      />
      <Text
        className={cn(
          className,
          !value && classes.show,
          !value && classes.active
        )}
      >
        {text}
      </Text>
    </label>
  );
};

ActiveLabel.propTypes = {
  labelChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
  className: PropTypes.string
};

export default ActiveLabel;
